import React from 'react';
import CompleteModal from "./complete-modal";

const TaskComplete = ({task, onRestudy, onNext, onExit, onSubmit, onClose,content}) => {
    return <CompleteModal
        title={window.L('teach.task') + window.L('teach.task.completed')}
        nextTitle={window.L('teach.task.nextTask')}
        restudyTitle={window.L('teach.task.restudy')}
        exitTitle={window.L('teach.lesson.exit')}
        onRestudy={onRestudy}
        onNext={onNext}
        onExit={onExit}
        onSubmit={onSubmit}
        onClose={onClose}
        content={content}
        />
}

export default TaskComplete;
